import { combineReducers } from '@reduxjs/toolkit';
import { appReducer } from './ui/app/reducer';
import { formReducer } from './ui/form/reducer';
import { mobileSummaryModalReducer } from './ui/mobileSummaryModal/reducer';

export const uiReducer = combineReducers({
	app: appReducer,
	form: formReducer,
	mobileSummaryModal: mobileSummaryModalReducer,
});
